import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

import { PageNotFoundComponent } from "./page-not-found.component";
import { SiUnauthorizedComponent } from "./shared/si-unauthorized/si-unauthorized.component";
import { AuthGuard } from "./auth.guard";
import { SiCustomerAccessComponent } from "./si-customer-access/si-customer-access.component";
import { SiCustomerAccessRedirectGuard } from "./si-customer-access-redirect.guard";
import { SiLandingPageComponent } from "@strategic-insights/ng-login-page-kc";
import { SiLogoutPageComponent } from "@strategic-insights/ng-login-page-kc";
import { SiLoginPageComponent } from "@strategic-insights/ng-login-page-kc";
import { SiInviteUserComponent } from "@strategic-insights/ng-login-page-kc";
import { SiResetPasswordComponent } from "@strategic-insights/ng-login-page-kc";
import { SiKeyCloakLoginComponent } from "./shared/si-keycloak-redirect/si-keycloak-login/si-keycloak-login.component";
import { SiKeyCloakLogoutComponent } from "./shared/si-keycloak-redirect/si-keycloak-logout/si-keycloak-logout.component";
import { SiKeyCloakSSOComponent } from "./shared/si-keycloak-redirect/si-keycloak-sso/si-keycloak-sso.component";
const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full",
  },
  {
    path: "home",
    component: SiLandingPageComponent,
  },
  {
    path: "logout",
    component: SiLogoutPageComponent,
  },
  {
    path: "login",
    component: SiLoginPageComponent,
  },
  {
    path: "customerAccess",
    component: SiCustomerAccessComponent,
    canActivate: [SiCustomerAccessRedirectGuard],
  },
  {
    path: "kcloginredirect",
    component: SiKeyCloakLoginComponent,
  },
  {
    path: "kclogoutredirect",
    component: SiKeyCloakLogoutComponent,
  },
  {
    path: "sso",
    component: SiKeyCloakSSOComponent,
  },
  {
    path: "frontier",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-frontier/si-customer-frontier.module"
      ).then((m) => m.SiCustomerFrontierModule),
    canLoad: [AuthGuard],
  },
  {
    path: "twilio",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-twilio/si-customer-twilio.module"
      ).then((m) => m.SiCustomerTwilioModule),
    canLoad: [AuthGuard],
  },
  {
    path: "peerless",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-peerless/si-customer-peerless.module"
      ).then((m) => m.SiCustomerPeerlessModule),
    canLoad: [AuthGuard],
  },
  {
    path: "pioneer",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-pioneer/si-customer-pioneer.module"
      ).then((m) => m.SiCustomerPioneerModule),
    canLoad: [AuthGuard],
  },
  {
    path: "altice",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-altice/si-customer-altice.module"
      ).then((m) => m.SiCustomerAlticeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "videotron",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-videotron/si-customer-videotron.module"
      ).then((m) => m.SiCustomerVideotronModule),
    canLoad: [AuthGuard],
  },
  {
    path: "orange",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-orange/si-customer-orange.module"
      ).then((m) => m.SiCustomerOrangeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "orangecarriers",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-orangecarriers/si-customer-orangecarriers.module"
      ).then((m) => m.SiCustomerOrangecarriersModule),
    canLoad: [AuthGuard],
  },
  {
    path: "ringcentral",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-ringcentral/si-customer-ringcentral.module"
      ).then((m) => m.SiCustomerRingcentralModule),
    canLoad: [AuthGuard],
  },
  {
    path: "vonage",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-vonage/si-customer-vonage.module"
      ).then((m) => m.SiCustomerVonageModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cox",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-cox/si-customer-cox.module").then(
        (m) => m.SiCustomerCoxModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "doximity",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-doximity/si-customer-doximity.module"
      ).then((m) => m.SiCustomerDoximityModule),
    canLoad: [AuthGuard],
  },
  {
    path: "inteliquent",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-inteliquent/si-customer-inteliquent.module"
      ).then((m) => m.SiCustomerInteliquentModule),
    canLoad: [AuthGuard],
  },
  {
    path: "inteliquentbeta",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-inteliquentbeta/si-customer-inteliquentbeta.module"
      ).then((m) => m.SiCustomerInteliquentbetaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "midco",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-midco/si-customer-midco.module").then(
        (m) => m.SiCustomerMidcoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "intrado",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-intrado/si-customer-intrado.module"
      ).then((m) => m.SiCustomerIntradoModule),
    canLoad: [AuthGuard],
  },
  {
    path: "rogers",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-rogers/si-customer-rogers.module"
      ).then((m) => m.SiCustomerRogersModule),
    canLoad: [AuthGuard],
  },
  {
    path: "demo",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-demo/si-customer-demo.module").then(
        (m) => m.SiCustomerDemoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "ziply",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-ziply/si-customer-ziply.module").then(
        (m) => m.SiCustomerZiplyModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "unitifiber",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-unitifiber/si-customer-unitifiber.module"
      ).then((m) => m.SiCustomerUnitifiberModule),
    canLoad: [AuthGuard],
  },
  {
    path: "btc",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-btc/si-customer-btc.module").then(
        (m) => m.SiCustomerBtcModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "cogeco",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-cogeco/si-customer-cogeco.module"
      ).then((m) => m.SiCustomerCogecoModule),
    canLoad: [AuthGuard],
  },
  {
    path: "nuso",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-nuso/si-customer-nuso.module").then(
        (m) => m.SiCustomerNusoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "allo",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-allo/si-customer-allo.module").then(
        (m) => m.SiCustomerAlloModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "callcentric",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-callcentric/si-customer-callcentric.module"
      ).then((m) => m.SiCustomerCallcentricModule),
    canLoad: [AuthGuard],
  },
  {
    path: "fuze",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-fuze/si-customer-fuze.module").then(
        (m) => m.SiCustomerFuzeModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "ecg",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-ecg/si-customer-ecg.module").then(
        (m) => m.SiCustomerEcgModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "bullseye",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bullseye/si-customer-bullseye.module"
      ).then((m) => m.SiCustomerBullseyeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "coredial",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-coredial/si-customer-coredial.module"
      ).then((m) => m.SiCustomerCoredialModule),
    canLoad: [AuthGuard],
  },
  {
    path: "default",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-default/si-customer-default.module"
      ).then((m) => m.SiCustomerDefaultModule),
    canLoad: [AuthGuard],
  },
  {
    path: "armstrong",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-armstrong/si-customer-armstrong.module"
      ).then((m) => m.SiCustomerArmstrongModule),
    canLoad: [AuthGuard],
  },
  {
    path: "bigriver",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bigriver/si-customer-bigriver.module"
      ).then((m) => m.SiCustomerBigriverModule),
    canLoad: [AuthGuard],
  },
  {
    path: "bellcanada",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bellcanada/si-customer-bellcanada.module"
      ).then((m) => m.SiCustomerBellcanadaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "pentestcompany",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-pentestcompany/si-customer-pentestcompany.module"
      ).then((m) => m.SiCustomerPentestcompanyModule),
    canLoad: [AuthGuard],
  },
  {
    path: "atmc",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-atmc/si-customer-atmc.module").then(
        (m) => m.SiCustomerATMCModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "windstream",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-frontier/si-customer-frontier.module"
      ).then((m) => m.SiCustomerFrontierModule),
    canLoad: [AuthGuard],
  },
  {
    path: "twilio",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-twilio/si-customer-twilio.module"
      ).then((m) => m.SiCustomerTwilioModule),
    canLoad: [AuthGuard],
  },
  {
    path: "peerless",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-peerless/si-customer-peerless.module"
      ).then((m) => m.SiCustomerPeerlessModule),
    canLoad: [AuthGuard],
  },
  {
    path: "pioneer",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-pioneer/si-customer-pioneer.module"
      ).then((m) => m.SiCustomerPioneerModule),
    canLoad: [AuthGuard],
  },
  {
    path: "altice",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-altice/si-customer-altice.module"
      ).then((m) => m.SiCustomerAlticeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "videotron",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-videotron/si-customer-videotron.module"
      ).then((m) => m.SiCustomerVideotronModule),
    canLoad: [AuthGuard],
  },
  {
    path: "orange",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-orange/si-customer-orange.module"
      ).then((m) => m.SiCustomerOrangeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "ringcentral",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-ringcentral/si-customer-ringcentral.module"
      ).then((m) => m.SiCustomerRingcentralModule),
    canLoad: [AuthGuard],
  },
  {
    path: "vonage",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-vonage/si-customer-vonage.module"
      ).then((m) => m.SiCustomerVonageModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cox",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-cox/si-customer-cox.module").then(
        (m) => m.SiCustomerCoxModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "doximity",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-doximity/si-customer-doximity.module"
      ).then((m) => m.SiCustomerDoximityModule),
    canLoad: [AuthGuard],
  },
  {
    path: "inteliquent",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-inteliquent/si-customer-inteliquent.module"
      ).then((m) => m.SiCustomerInteliquentModule),
    canLoad: [AuthGuard],
  },
  {
    path: "inteliquentbeta",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-inteliquentbeta/si-customer-inteliquentbeta.module"
      ).then((m) => m.SiCustomerInteliquentbetaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "midco",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-midco/si-customer-midco.module").then(
        (m) => m.SiCustomerMidcoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "intrado",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-intrado/si-customer-intrado.module"
      ).then((m) => m.SiCustomerIntradoModule),
    canLoad: [AuthGuard],
  },
  {
    path: "rogers",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-rogers/si-customer-rogers.module"
      ).then((m) => m.SiCustomerRogersModule),
    canLoad: [AuthGuard],
  },
  {
    path: "demo",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-demo/si-customer-demo.module").then(
        (m) => m.SiCustomerDemoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "ziply",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-ziply/si-customer-ziply.module").then(
        (m) => m.SiCustomerZiplyModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "unitifiber",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-unitifiber/si-customer-unitifiber.module"
      ).then((m) => m.SiCustomerUnitifiberModule),
    canLoad: [AuthGuard],
  },
  {
    path: "btc",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-btc/si-customer-btc.module").then(
        (m) => m.SiCustomerBtcModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "cogeco",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-cogeco/si-customer-cogeco.module"
      ).then((m) => m.SiCustomerCogecoModule),
    canLoad: [AuthGuard],
  },
  {
    path: "nuso",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-nuso/si-customer-nuso.module").then(
        (m) => m.SiCustomerNusoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "allo",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-allo/si-customer-allo.module").then(
        (m) => m.SiCustomerAlloModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "callcentric",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-callcentric/si-customer-callcentric.module"
      ).then((m) => m.SiCustomerCallcentricModule),
    canLoad: [AuthGuard],
  },
  {
    path: "fuze",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-fuze/si-customer-fuze.module").then(
        (m) => m.SiCustomerFuzeModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "ecg",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-ecg/si-customer-ecg.module").then(
        (m) => m.SiCustomerEcgModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "bullseye",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bullseye/si-customer-bullseye.module"
      ).then((m) => m.SiCustomerBullseyeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "coredial",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-coredial/si-customer-coredial.module"
      ).then((m) => m.SiCustomerCoredialModule),
    canLoad: [AuthGuard],
  },
  {
    path: "default",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-default/si-customer-default.module"
      ).then((m) => m.SiCustomerDefaultModule),
    canLoad: [AuthGuard],
  },
  {
    path: "armstrong",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-armstrong/si-customer-armstrong.module"
      ).then((m) => m.SiCustomerArmstrongModule),
    canLoad: [AuthGuard],
  },
  {
    path: "bigriver",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bigriver/si-customer-bigriver.module"
      ).then((m) => m.SiCustomerBigriverModule),
    canLoad: [AuthGuard],
  },
  {
    path: "bellcanada",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bellcanada/si-customer-bellcanada.module"
      ).then((m) => m.SiCustomerBellcanadaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "pentestcompany",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-pentestcompany/si-customer-pentestcompany.module"
      ).then((m) => m.SiCustomerPentestcompanyModule),
    canLoad: [AuthGuard],
  },
  {
    path: "digitalconnections",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-digitalconnections/si-customer-digitalconnections.module"
      ).then((m) => m.SiCustomerDigitalconnectionsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "visioncts",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-visioncts/si-customer-visioncts.module"
      ).then((m) => m.SiCustomerVisionctsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dandpcommunications",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dandpcommunications/si-customer-dandpcommunications.module"
      ).then((m) => m.SiCustomerDandpcommunicationsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "champlaintechnology",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-champlaintechnology/si-customer-champlaintechnology.module"
      ).then((m) => m.SiCustomerChamplaintechnologyModule),
    canLoad: [AuthGuard],
  },
  {
    path: "ibasis",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-ibasis/si-customer-ibasis.module"
      ).then((m) => m.SiCustomerIbasisModule),
    canLoad: [AuthGuard],
  },
  {
    path: "convergia",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-convergia/si-customer-convergia.module"
      ).then((m) => m.SiCustomerConvergiaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "intermetrocommunications",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-intermetrocommunications/si-customer-intermetrocommunications.module"
      ).then((m) => m.SiCustomerIntermetrocommunicationsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "capitalone",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-capitalone/si-customer-capitalone.module"
      ).then((m) => m.SiCustomerCapitaloneModule),
    canLoad: [AuthGuard],
  },
  {
    path: "akabis",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-akabis/si-customer-akabis.module"
      ).then((m) => m.SiCustomerAkabisModule),
    canLoad: [AuthGuard],
  },
  {
    path: "atlink",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-atlink/si-customer-atlink.module"
      ).then((m) => m.SiCustomerAtlinkModule),
    canLoad: [AuthGuard],
  },
  {
    path: "pncbank",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-pncbank/si-customer-pncbank.module"
      ).then((m) => m.SiCustomerPncbankModule),
    canLoad: [AuthGuard],
  },
  {
    path: "odigo",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-odigo/si-customer-odigo.module").then(
        (m) => m.SiCustomerOdigoModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "oracle",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-oracle/si-customer-oracle.module"
      ).then((m) => m.SiCustomerOracleModule),
    canLoad: [AuthGuard],
  },
  {
    path: "lancktelecom",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-lancktelecom/si-customer-lancktelecom.module"
      ).then((m) => m.SiCustomerLancktelecomModule),
    canLoad: [AuthGuard],
  },
  {
    path: "tbaytel",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-tbaytel/si-customer-tbaytel.module"
      ).then((m) => m.SiCustomerTbaytelModule),
    canLoad: [AuthGuard],
  },
  {
    path: "fluentstream",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-fluentstream/si-customer-fluentstream.module"
      ).then((m) => m.SiCustomerFluentstreamModule),
    canLoad: [AuthGuard],
  },
  {
    path: "keybank",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-keybank/si-customer-keybank.module"
      ).then((m) => m.SiCustomerKeybankModule),
    canLoad: [AuthGuard],
  },
  {
    path: "transunioncontactcenter",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-transunioncontactcenter/si-customer-transunioncontactcenter.module"
      ).then((m) => m.SiCustomerTransunioncontactcenterModule),
    canLoad: [AuthGuard],
  },
  {
    path: "alticeh",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-alticeh/si-customer-alticeh.module"
      ).then((m) => m.SiCustomerAlticehModule),
    canLoad: [AuthGuard],
  },
  {
    path: "ccicompanytest",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-ccicompanytest/si-customer-ccicompanytest.module"
      ).then((m) => m.SiCustomerCCICompanyTestModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dpcompanywithcci",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dpcompanywithcci/si-customer-dpcompanywithcci.module"
      ).then((m) => m.SiCustomerDpCompanyWithCCIModule),
    canLoad: [AuthGuard],
  },
  {
    path: "inviteUserForm",
    component: SiInviteUserComponent,
  },
  {
    path: "atmc",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-atmc/si-customer-atmc.module").then(
        (m) => m.SiCustomerATMCModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "windstream",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-windstream/si-customer-windstream.module"
      ).then((m) => m.SiCustomerWindstreamModule),
    canLoad: [AuthGuard],
  },
  {
    path: "firstlight",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-firstlight/si-customer-firstlight.module"
      ).then((m) => m.SiCustomerFirstLightModule),
    canLoad: [AuthGuard],
  },
  {
    path: "firstcomm",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-firstcomm/si-customer-firstcomm.module"
      ).then((m) => m.SiCustomerFirstCommModule),
    canLoad: [AuthGuard],
  },
  {
    path: "neustartrustid",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-neustartrustid/si-customer-neustartrustid.module"
      ).then((m) => m.SiCustomerNeustarTrustIDModule),
    canLoad: [AuthGuard],
  },
  {
    path: "consolidated",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-consolidated/si-customer-consolidated.module"
      ).then((m) => m.SiCustomerConsolidatedModule),
    canLoad: [AuthGuard],
  },
  {
    path: "telus",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-telus/si-customer-telus.module").then(
        (m) => m.SiCustomerTelusModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "teliax",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-teliax/si-customer-teliax.module"
      ).then((m) => m.SiCustomerTeliaxModule),
    canLoad: [AuthGuard],
  },
  {
    path: "five9",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-five9/si-customer-five9.module").then(
        (m) => m.SiCustomerFive9Module
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "five9h",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-five9h/si-customer-five9h.module"
      ).then((m) => m.SiCustomerFive9HModule),
    canLoad: [AuthGuard],
  },
  {
    path: "logmein",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-logmein/si-customer-logmein.module"
      ).then((m) => m.SiCustomerLogmeinModule),
    canLoad: [AuthGuard],
  },
  {
    path: "saddleback",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-saddleback/si-customer-saddleback.module"
      ).then((m) => m.SiCustomerSaddlebackModule),
    canLoad: [AuthGuard],
  },
  {
    path: "iristel",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-iristel/si-customer-iristel.module"
      ).then((m) => m.SiCustomerIristelModule),
    canLoad: [AuthGuard],
  },
  {
    path: "eastlink",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-eastlink/si-customer-eastlink.module"
      ).then((m) => m.SiCustomerEastlinkModule),
    canLoad: [AuthGuard],
  },
  {
    path: "logix",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-logix/si-customer-logix.module").then(
        (m) => m.SiCustomerLogixModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "gtt",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-gtt/si-customer-gtt.module").then(
        (m) => m.SiCustomerGTTModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "cdk",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-cdk/si-customer-cdk.module").then(
        (m) => m.SiCustomerCDKModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "intelepeer",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-intelepeer/si-customer-intelepeer.module"
      ).then((m) => m.SiCustomerIntelepeerModule),
    canLoad: [AuthGuard],
  },
  {
    path: "granite",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-granite/si-customer-granite.module"
      ).then((m) => m.SiCustomerGraniteModule),
    canLoad: [AuthGuard],
  },
  {
    path: "lightwave",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-lightwave/si-customer-lightwave.module"
      ).then((m) => m.SiCustomerLightwaveModule),
    canLoad: [AuthGuard],
  },
  {
    path: "bluetone",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bluetone/si-customer-bluetone.module"
      ).then((m) => m.SiCustomerBluetoneModule),
    canLoad: [AuthGuard],
  },
  {
    path: "flowroute",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-flowroute/si-customer-flowroute.module"
      ).then((m) => m.SiCustomerFlowrouteModule),
    canLoad: [AuthGuard],
  },
  {
    path: "tata",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-tata/si-customer-tata.module").then(
        (m) => m.SiCustomerTataModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "sipnav",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-sipnav/si-customer-sipnav.module"
      ).then((m) => m.SiCustomerSIPNavModule),
    canLoad: [AuthGuard],
  },
  {
    path: "chickasaw",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-chickasaw/si-customer-chickasaw.module"
      ).then((m) => m.SiCustomerChickasawModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cloudli",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-cloudli/si-customer-cloudli.module"
      ).then((m) => m.SiCustomerCloudliModule),
    canLoad: [AuthGuard],
  },
  {
    path: "accessone",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-accessone/si-customer-accessone.module"
      ).then((m) => m.SiCustomerAccessoneModule),
    canLoad: [AuthGuard],
  },
  {
    path: "snet",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-snet/si-customer-snet.module").then(
        (m) => m.SiCustomerSnetModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "bluerock",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bluerock/si-customer-bluerock.module"
      ).then((m) => m.SiCustomerBluerockModule),
    canLoad: [AuthGuard],
  },
  {
    path: "teligentip",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-teligentip/si-customer-teligentip.module"
      ).then((m) => m.SiCustomerTeligentipModule),
    canLoad: [AuthGuard],
  },
  {
    path: "phonexa",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-phonexa/si-customer-phonexa.module"
      ).then((m) => m.SiCustomerPhonexaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "avaya",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-avaya/si-customer-avaya.module").then(
        (m) => m.SiCustomerAvayaModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "dandpcommunications",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dandpcommunications/si-customer-dandpcommunications.module"
      ).then((m) => m.SiCustomerDandpcommunicationsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "genesys",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-genesys/si-customer-genesys.module"
      ).then((m) => m.SiCustomerGenesysModule),
    canLoad: [AuthGuard],
  },
  {
    path: "telush",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-telush/si-customer-telush.module"
      ).then((m) => m.SiCustomerTelushModule),
    canLoad: [AuthGuard],
  },
  {
    path: "sutherlandus",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-sutherlandus/si-customer-sutherlandus.module"
      ).then((m) => m.SiCustomerSutherlandusModule),
    canLoad: [AuthGuard],
  },
  {
    path: "iqor",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-iqor/si-customer-iqor.module").then(
        (m) => m.SiCustomerIqorModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "ienergizer",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-ienergizer/si-customer-ienergizer.module"
      ).then((m) => m.SiCustomerIenergizerModule),
    canLoad: [AuthGuard],
  },
  {
    path: "creditone",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-creditone/si-customer-creditone.module"
      ).then((m) => m.SiCustomerCreditoneModule),
    canLoad: [AuthGuard],
  },
  {
    path: "firstcredit",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-firstcredit/si-customer-firstcredit.module"
      ).then((m) => m.SiCustomerFirstcreditModule),
    canLoad: [AuthGuard],
  },
  {
    path: "alorica",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-alorica/si-customer-alorica.module"
      ).then((m) => m.SiCustomerAloricaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "google",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-google/si-customer-google.module"
      ).then((m) => m.SiCustomerGoogleModule),
    canLoad: [AuthGuard],
  },
  {
    path: "aetnachs",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-aetnachs/si-customer-aetnachs.module"
      ).then((m) => m.SiCustomerAetnaChsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cvscorporation",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-cvscorporation/si-customer-cvscorporation.module"
      ).then((m) => m.SiCustomerCVSCorporationModule),
    canLoad: [AuthGuard],
  },
  {
    path: "amazonretailgroup",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-amazonretailgroup/si-customer-amazonretailgroup.module"
      ).then((m) => m.SiCustomerAmazonRetailGroupModule),
    canLoad: [AuthGuard],
  },
  {
    path: "rategravityinc",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-rategravityinc/si-customer-rategravityinc.module"
      ).then((m) => m.SiCustomerRateGravityIncModule),
    canLoad: [AuthGuard],
  },
  {
    path: "firstfinancialbank",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-firstfinancialbank/si-customer-firstfinancialbank.module"
      ).then((m) => m.SiCustomerFirstfinancialbankModule),
  },
  {
    path: "sr56company",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-sr56company/si-customer-sr56company.module"
      ).then((m) => m.SiCustomerSR56CompanyModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dpccicacarrier",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dpccicacarrier/si-customer-dpccicacarrier.module"
      ).then((m) => m.SiCustomerDPCCICACarrierModule),
    canLoad: [AuthGuard],
  },
  {
    path: "dpccicacarrierent",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-dpccicacarrierent/si-customer-dpccicacarrierent.module"
      ).then((m) => m.SiCustomerDPCCICACarrierEntModule),
    canLoad: [AuthGuard],
  },
  {
    path: "samltest",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-samltest/si-customer-samltest.module"
      ).then((m) => m.SiCustomerSamlTestModule),
    canLoad: [AuthGuard],
  },
  {
    path: "att",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-att/si-customer-att.module").then(
        (m) => m.SiCustomerAttModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "northwesternmutual",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-northwesternmutual/si-customer-northwesternmutual.module"
      ).then((m) => m.SiCustomerNorthwesternMutualModule),
    canLoad: [AuthGuard],
  },
  {
    path: "alternatesolutions",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-alternatesolutions/si-customer-alternatesolutions.module"
      ).then((m) => m.SiCustomerAlternateSolutionsModule),
    canLoad: [AuthGuard],
  },
  {
    path: "firstnationalbankofpennsylvania",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-firstnationalbankofpennsylvania/si-customer-firstnationalbankofpennsylvania.module"
      ).then((m) => m.SiCustomerFirstNationalBankofPennsylvaniaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "bcdadmin",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bcdadmin/si-customer-bcdadmin.module"
      ).then((m) => m.SiCustomerAdminModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cci",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-cci/si-customer-cci.module").then(
        (m) => m.SiCustomerCciModule
      ),
    //canLoad: [AuthGuard],
  },
  {
    path: "bancfirst",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-bancfirst/si-customer-bancfirst.module"
      ).then((m) => m.SiCustomerBancfirstModule),
    canLoad: [AuthGuard],
  },
  {
    path: "pacificlife",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-pacificlife/si-customer-pacificlife.module"
      ).then((m) => m.SiCustomerPacificlifeModule),
    canLoad: [AuthGuard],
  },
  {
    path: "knoxvilletva",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-knoxvilletva/si-customer-knoxvilletva.module"
      ).then((m) => m.SiCustomerKnoxvilletvaModule),
    canLoad: [AuthGuard],
  },
  {
    path: "libertymutual",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-libertymutual/si-customer-libertymutual.module"
      ).then((m) => m.SiCustomerLibertymutualModule),
    canLoad: [AuthGuard],
  },
  {
    path: "chubbcorporation",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-chubbcorporation/si-customer-chubbcorporation.module"
      ).then((m) => m.SiCustomerChubbcorporationModule),
    canLoad: [AuthGuard],
  },
  {
    path: "inteliquenth",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-inteliquenth/si-customer-inteliquenth.module"
      ).then((m) => m.SiCustomerInteliquenthModule),
    canLoad: [AuthGuard],
  },
  {
    path: "forumcreditunion",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-forumcreditunion/si-customer-forumcreditunion.module"
      ).then((m) => m.SiCustomerForumcreditunionModule),
    canLoad: [AuthGuard],
  },
  {
    path: "jpmorganchase",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-jpmorganchase/si-customer-jpmorganchase.module"
      ).then((m) => m.SiCustomerJPMorganChaseModule),
    canLoad: [AuthGuard],
  },
  {
    path: "newlybooked",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-newlybooked/si-customer-newlybooked.module"
      ).then((m) => m.SiCustomerNewlybookedModule),
    canLoad: [AuthGuard],
  },
  {
    path: "usaa",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-usaa/si-customer-usaa.module").then(
        (m) => m.SiCustomerUsaaModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "facetwealth",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-facetwealth/si-customer-facetwealth.module"
      ).then((m) => m.SiCustomerFacetwealthModule),
    canLoad: [AuthGuard],
  },
  {
    path: "cigna",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-cigna/si-customer-cigna.module").then(
        (m) => m.SiCustomerCignaModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: "vystarcreditunion",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-vystarcreditunion/si-customer-vystarcreditunion.module"
      ).then((m) => m.SiCustomerVystarcreditunionModule),
    canLoad: [AuthGuard],
  },
  {
    path: "farmersinsurance",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-farmersinsurance/si-customer-farmersinsurance.module"
      ).then((m) => m.SiCustomerFarmersinsuranceModule),
    canLoad: [AuthGuard],
  },
  {
    path: "umbbank",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        "./si-customers/si-customer-umbbank/si-customer-umbbank.module"
      ).then((m) => m.SiCustomerUmbbankModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'zoomcommunications',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-zoomcommunications/si-customer-zoomcommunications.module').then(m => m.SiCustomerZoomcommunicationsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'wellsfargo',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-wellsfargo/si-customer-wellsfargo.module').then(m => m.SiCustomerWellsfargoModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'voipnetworks',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-voipnetworks/si-customer-voipnetworks.module').then(m => m.SiCustomerVoipnetworksModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'sinchvoiceprogramming',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-sinchvoiceprogramming/si-customer-sinchvoiceprogramming.module').then(m => m.SiCustomerSinchVoiceProgrammingModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'jpmorganenterprisecno',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-jpmorganenterprisecno/si-customer-jpmorganenterprisecno.module').then(m => m.SiCustomerJPMorganEnterpriseCNOModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'astoundbroadband',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-astoundbroadband/si-customer-astoundbroadband.module').then(m => m.SiCustomerAstoundModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'digitaltrust',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-digitaltrust/si-customer-digitaltrust.module').then(m => m.SiCustomerDigitaltrustModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'missionlane',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-missionlane/si-customer-missionlane.module').then(m => m.SiCustomerMissionlaneModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'allstatecorporation',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-allstatecorporation/si-customer-allstatecorporation.module').then(m => m.SiCustomerAllstatecorporationModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'charlesschwab',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-customers/si-customer-charlesschwab/si-customer-charlesschwab.module').then(m => m.SiCustomerCharlesSchwabModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'auditlog',
    canActivate: [AuthGuard],
    loadChildren: () => import('./si-auditlog/si-auditlog.module').then(m => m.SiAuditlogModule),
    canLoad: [AuthGuard]
  },
  {
    path: "inviteUserForm",
    component: SiInviteUserComponent,
  },
  {
    path: "unauthorized",
    component: SiUnauthorizedComponent,
  },
  {
    path: "resetPassword",
    component: SiResetPasswordComponent,
  },
  {
    path: "**",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./si-customers/si-customer-cci/si-customer-cci.module").then(
        (m) => m.SiCustomerCciModule
      ),
    canLoad: [AuthGuard],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, { enableTracing: false, useHash: true }),
  ],
  declarations: [PageNotFoundComponent],
  exports: [RouterModule],
})
export class AppRoutingModule {}
